import axios from "axios";
import { API_ENDPOINTS } from "../../config";

const normalizeToken = (t) => {
  const raw = String(t ?? "").trim();
  if (!raw) return "";
  return raw.replace(/^Bearer\s+/i, "").trim();
};

async function goOffline(token) {
  const raw = normalizeToken(token ?? localStorage.getItem("JWToken"));
  if (!raw) return null;

  const url = API_ENDPOINTS.GOOFFLINE || API_ENDPOINTS.GO_OFFLINE;
  if (!url) throw new Error("Missing GOOFFLINE endpoint in API_ENDPOINTS");

  try {
    const response = await axios.delete(url, {
      headers: {
        "Content-Type": "application/json",
        "Authorization": `Bearer ${raw}`
      }
    });
    return response.status;
  } catch (error) {
    const status = error?.response?.status;
    if (status === 404) return null;
    console.error("GoOffline hiba:", error);
    throw error;
  }
}

export default goOffline;